import { render, staticRenderFns } from "./ring-chart.vue?vue&type=template&id=d72d4e2c&"
import script from "./ring-chart.vue?vue&type=script&lang=js&"
export * from "./ring-chart.vue?vue&type=script&lang=js&"
import style0 from "./ring-chart.vue?vue&type=style&index=0&id=d72d4e2c&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports